const config = {
    API_HOST: '',
    API_PROXY: 'http://api-uat.sbremit.co.uk'
}

export default config;